<template>
  <div class="keyvisual">
    <div id="key">
      <img class="keyimg" src="/img/top/tsuruhakey.png">
      <div class="explanation">
        <div class="highlight">
          <p class="endtext">たくさんのご参加ありがとうございました。</p>
          <p class="endtext">各コンテンツの配信は4月1日まで<br>（一部を除き）視聴できます。</p>
        </div>
        <div class="messagebox">
          <p class="topmessage">全国だれでも、おうちで楽しめるオンライン親子イベント。<br>豪華ゲストによるステージや企業からのお得な情報を配信！</p>
          <p class="topmessage">ツルハドラッグで使える商品券10万円分など</p><p class="topmessage">豪華賞品が当たる抽選会も★無料参加チケットを取得しよう！</p>
        </div>
      </div>
      <div class="box">
        <a id="schedule-url" class="link" href="https://festa.l-ma.co.jp/202010/tsuruha/about/" target="_blank">
          <span class="button">オンラインフェスタの楽しみ方</span>
          <img class="arrow" src="/img/top/arrow.png">
        </a>
      </div>
      <ul class="flex">
        <li class="txtbox"><p class="title">メインチャンネル</p><p class="message">スペシャルゲストとして出口たかしさんが登場！親子で楽しめる歌やダンスのステージのほか、ツルハドラッグから暮らしのヒントになる情報をお届けします。</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/main2.png"></li>
      </ul>
      <ul class="flex">
        <li class="txtbox"><p class="title">キーワード付き<br>企業LIVE</p><p class="message">美と健康をテーマに子育て応援企業やメーカーが約40社集合！配信中に発表されるキーワードを５つ集めて抽選会に応募しよう！</p><p class="message red">※プレゼント抽選会は終了しました。</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/company.png"></li>
      </ul>
      <ul class="flex">
        <li class="txtbox"><p class="title">ママチャンネル</p><p class="message">オンライン交流会や育児セミナー、ワークショップ体験など、東京・仙台・北海道のママ主催者による楽しいコンテンツが盛りだくさん♪</p></li>
        <li class="imgbox"><img class="sendaiimg" src="/img/top/provider.png"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { setUrlForEvent2 } from '@/helpers/utils.js'

export default {
  mounted () {
    setUrlForEvent2('schedule-url')
  }
}
</script>

<style lang="sass" scoped>
.keyvisual
  max-width: 600px
  margin: 0 auto
  padding: 45px 0 10px 0
.explanation
 margin-top: 20px
.highlight
  margin-bottom: 30px
  text-align: center
  .endtext
    font-size: 18px
    font-weight: bold
    margin-bottom: 10px
.topmessage
  text-align: center
  font-size: 13px
  line-height: 22px
.note
  text-align: center
  margin-top: 10px
  font-size: 13px
  line-height: 22px
  color: #FF0000
.box
  padding: 40px 0 30px 0
  text-align: center
.link
  position: relative
  background-color: #ED84A5
  padding: 20px 50px
  border-radius: 8px
  max-width: 335px
  margin: 35px auto 30px auto
  width: 100%
  box-shadow: 2px 2px 4px gray
.button
  color: #fff
  font-weight: bold
.arrow
  position: absolute
  width: 40px
  top: 18px
  left: 255px
ul
  display: flex
  align-items: center
  justify-content: center
  overflow: hidden
  letter-spacing: -.5em
  margin: 25px 10px
li
  display: inline-block
  width: 50%
  letter-spacing: 0
  text-align: center
  margin: 0 0 15px 35px
  .title
    font-size: 16px
    color: #00AB3D
    margin: 10px 0
    font-weight: bold
  .message
    text-align: left
    font-size: 12px
    color: #666
    line-height: 20px
    &.red
      color: #FF0000
  img
    max-width: 80%
@media screen and (max-width: 440px)
  li
    margin: 0 0 15px 10px
</style>
